module.exports = __webpack_public_path__ + "img/logo.3379ade2.png";